export interface NotificationListInput {
  notificationGroup: string;
  lastKey?: string;
  limit: number;
}

export interface NotificationList {
  items: Notification[];
  lastKey: string | null;
}


export interface Notification {
    notificationId: string;
    novelId: string;
    message: string;
    iconUrl: string;
    createdAt: string;
    isRead: boolean;
}

export interface NotificationSummary {
    userId: string;
    notificationGroup: string;
    unreadItemCount: number;
    createdAt: string;
    updatedAt: string;
}
